// @flow
import {
    CursorSpinner,
    WebComponent,
} from 'fg-frontend';

export default class EshopUserToolsHandler extends WebComponent {
    constructor(props) {
        super(props);
        this.handleSubmit = this.handleSubmit.bind(this);
    }
    didMount() {
        this.on('submit', this.handleSubmit);
    }
    handleSubmit(event) {
        const {
            activeClass,
        } = this.props;

        event.preventDefault();

        const submitElement = this.element.querySelector('[type="submit"]');
        const buttonLabel = submitElement.querySelector('.button-label');

        const xhr = new XMLHttpRequest();
        const formData = new FormData(this.element);
        const requestUrl = this.element.getAttribute('action');
        formData.append(submitElement.name, submitElement.value);

        CursorSpinner.pushToQueue('eshopUserToolsHandle');

        xhr.onload = () => {
            if (xhr.status == 200) {
                //eshopUserToolsRefresh();

                if (submitElement.classList.contains(activeClass)) {
                    submitElement.name = submitElement.name.replace('removeItemFromList','addItemToList');
                    buttonLabel.innerHTML = submitElement.getAttribute('data-default-title');
                } else {
                    submitElement.name = submitElement.name.replace('addItemToList','removeItemFromList');
                    buttonLabel.innerHTML = submitElement.getAttribute('data-active-title');
                }

                submitElement.classList.toggle(activeClass);
            }
            CursorSpinner.removeFromQueue('eshopUserToolsHandle');
        };

        xhr.open('post',requestUrl, true);
        xhr.send(formData);
    }
}


// WEBPACK FOOTER //
// ./fe/web-default/src/js/components/configurator/EshopUserToolsHandler.js